export const zeroWidthSpace = '\u200B';
